import { useEffect } from 'react';
import usePrevious from './usePrevious';

const getTopScroll = (errors) => {
  let topScroll = 0;
  errors.forEach((el) => {
    const elTop = el.getBoundingClientRect().top;
    if (elTop < topScroll) {
      topScroll = elTop;
    }
  });
  return topScroll;
};

const useScrollToErrors = (hasFieldError, hasGlobalError, loading) => {
  const previousLoading = usePrevious(loading);
  useEffect(() => {
    let timeout;
    if (previousLoading && !loading) {
      // wait for the field errors and global errors to show up
      timeout = setTimeout(() => {
        if (hasFieldError) {
          const topScroll = getTopScroll(document.querySelectorAll('.form-group.error'));

          if (topScroll) {
            const top = window.scrollY || window.pageYOffset;
            window.scrollTo(0, top + topScroll);
            return;
          }
        }

        if (hasGlobalError) {
          const topScroll = getTopScroll(document.querySelectorAll('.error-msg'));

          if (topScroll) {
            const top = window.scrollY || window.pageYOffset;
            window.scrollTo(0, top + topScroll);
          }
        }
      }, 10);
    }
    return () => timeout && clearTimeout(timeout);
  }, [hasFieldError, hasGlobalError, loading, previousLoading]);
};

export default useScrollToErrors;
